import { config } from './config';
import { tokenManager } from './auth/tokenManager';

// Helper function for authenticated requests
const makeAuthenticatedRequest = async (url: string, options: RequestInit = {}) => {
  return tokenManager.makeAuthenticatedRequest(url, {
    ...options,
    headers: {
      'x-api-token': config.API_SECRET_TOKEN,
      ...options.headers,
    },
  });
};

const handleApiError = async (response: Response, operation: string) => {
  let errorData;
  try {
    const data = await response.json();
    if (Array.isArray(data.detail)) {
      errorData = data.detail[0]?.msg || data.detail[0]?.message;
    } else {
      errorData = data.detail || data.message || data.error || response.statusText;
    }
  } catch (e) {
    errorData = response.statusText;
  }

  if (errorData) {
    throw new Error(errorData);
  }

  throw new Error(`${operation} failed: ${response.statusText}`);
};

export const apiHelpers = {
  makeAuthenticatedRequest,
  handleApiError,
};